<p-dialog [(visible)]="visible"
          [modal]="true"
          [dismissableMask]="true"
          [style]="{ width: '99vw'}"
          [contentStyle]="{ height: '99vh' }"
          data-testid="log-viewer-modal">
  <ng-template #header>
    <div class="log-viewer-header">
      <span class="log-viewer-header-title">Application Logs</span>
      <div class="log-viewer-refresh-wrapper"
           [style.background]="refreshPieBackground()"
           [pTooltip]="secondsUntilNextRefresh() + 's until next refresh'"
           tooltipPosition="bottom">
        <p-button icon="pi pi-refresh"
                  [rounded]="true"
                  [text]="true"
                  severity="secondary"
                  styleClass="log-viewer-refresh-btn"
                  ariaLabel="Refresh logs"
                  (onClick)="refreshLogs()"
                  data-testid="log-viewer-refresh-button" />
      </div>
    </div>
  </ng-template>
  <app-log-table [logs]="parsedLogs()" />
</p-dialog>